import { cn } from "@/lib/utils";

export function Skeleton({
  className,
  shimmer = false,
}: {
  className?: string;
  shimmer?: boolean;
}) {
  return (
    <div
      className={cn(
        "rounded-sm",
        shimmer ? "skeleton-shimmer" : "animate-pulse bg-line/70",
        className
      )}
    />
  );
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  meta,
  tone = "default",
  card = false,
  className,
}: {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  meta?: React.ReactNode;
  tone?: "default" | "positive";
  card?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center gap-3 text-center",
        card ? "rounded-lg border border-line bg-surface px-6 py-12" : "px-6 py-14",
        className
      )}
    >
      {icon && (
        <div
          className={cn(
            "grid place-items-center rounded-full border text-2xl",
            card ? "size-16" : "size-12",
            tone === "positive" ? "border-success-border bg-success-soft" : "border-line bg-bg"
          )}
        >
          {icon}
        </div>
      )}
      <div className="text-base font-bold text-ink">{title}</div>
      {description && <p className="max-w-[400px] text-sm leading-relaxed text-muted">{description}</p>}
      {action}
      {meta && <div className="text-xs text-muted">{meta}</div>}
    </div>
  );
}
